
const BASE_URL_STORAGE = 'https://storage.googleapis.com';
const API_CLOUD_FUNCTIONS_DOWNLOAD = 'https://us-central1-poc-banco-estado.cloudfunctions.net';
const TOKEN_DOWNLOAD = '2Oew0WAwst1DA65';
const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const defaultTextImage = "Datos agregados del estudio de encuesta de bienestar de los chilenos en modo covid realizado por la mutual de seguros de chile en el periodo 2020 y 2021.";

exports.BASE_URL_STORAGE = BASE_URL_STORAGE;
exports.API_CLOUD_FUNCTIONS_DOWNLOAD = API_CLOUD_FUNCTIONS_DOWNLOAD;
exports.TOKEN_DOWNLOAD = TOKEN_DOWNLOAD;
exports.regexEmail = regexEmail;
exports.defaultTextImage = defaultTextImage;